import React from 'react';
import SelectField from 'customField/SelectField';
import { Field, FastField } from 'formik';

/**
 *
 * @param {Object} props
 * @param {string} props.name
 * @param {any} props.label
 * @param {string} props.placeholder
 * @param {string} props.classNameContainer - Class name of div that wrapping label, input and error message
 * @param {string} props.classNameLabel
 * @param {{ label: any, value: string | number }} props.options
 * @param {boolean} props.isFastField
 * @param {boolean} props.v2
 * @param {boolean} props.isMulti
 * @param {boolean} props.isClearable
 * @param {boolean} props.isDisabled
 * @param {boolean} props.isLoading
 * @param {boolean} props.required
 * @param {Object} props.style
 * @param {boolean} props.closeMenuOnSelect
 * @param {(event | valueSelected) => void} props.afterOnChange - if v2 enabled -> params will be value that selected: (valueSelected) => void
 * @param {string} props.v2Placeholder - placeholder for v2
 * @returns
 */
const Select = (props) => {
  const FieldWrapper = props.isFastField ? FastField : Field;
  return <FieldWrapper component={SelectField} {...props} />;
};

export default Select;
